export default __webpack_public_path__ + "static/media/25.8a996bfc.gif";